module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h5', [_vm._v(_vm._s(_vm.user.firstname + ' ' + _vm.user.surname))]), _vm._v(" "), (_vm.online['.value']) ? _c('span', {
    staticClass: "active"
  }, [_vm._v("Online Now")]) : _c('span', [_vm._v("Offline")])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-3be962d4"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/chat/naming/FullName.vue
// module id = 704
// module chunks = 1